import { createSlice } from '@reduxjs/toolkit';

export interface StoreState {
    shouldShowModal: boolean;
}

const slice = createSlice({
    name: 'AUTHORIZATION_MODAL',
    initialState: { shouldShowModal: false },
    reducers: {
        showModal: (state: StoreState) => {
            state.shouldShowModal = true;
        },
        closeModal: (state: StoreState) => {
            state.shouldShowModal = false;
        },
    },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
